---
seo:
  title: Appointment Stats
  description: view your appointment stats here
---

# **Appointment Stats**

Monitor your appointment statistics from your **Admin>Appointment Stats** dashboard, or via your daily appointment email.

These statistics allow you to set your appointment goals and monitor your progress to make sure you know exactly how your practice is tracking.

_Learn how to setup your appointment goals [here](/staff/settings/company-settings/appointment-goals)_

![appointment_stats](./assets/appointment_stats.png)
